module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar-left"
  }, [_c('div', {
    staticClass: "sidebar-left__inner"
  }, [_c('div', {
    staticClass: "sidebar-left__top",
    style: ({
      borderRightColor: _vm.theme.border2,
      borderBottomColor: _vm.theme.border,
      backgroundColor: _vm.theme.navbar
    })
  }, [_c('svg', {
    staticClass: "icon icon-list",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    },
    on: {
      "click": _vm.toggleSidebarLeft
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconList"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-left__list",
    style: ({
      color: _vm.theme.text2,
      backgroundColor: _vm.theme.background,
      borderColor: _vm.theme.border3
    })
  }, [_vm._l((_vm.folderListSnap), function(folder, index) {
    return _c('div', {
      key: index,
      staticClass: "folder"
    }, [_c('input', {
      staticClass: "folder__radio",
      attrs: {
        "type": "radio",
        "id": ("folder" + index),
        "name": "folder"
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "folder__title",
      attrs: {
        "for": ("folder" + index)
      },
      on: {
        "click": function($event) {
          return _vm.handleFolderClick(("folder" + index))
        }
      }
    }, [_c('svg', {
      staticClass: "icon-caret",
      attrs: {
        "fill": _vm.theme.icon2,
        "width": "24",
        "height": "24"
      }
    }, [_c('use', {
      attrs: {
        "href": "#iconCaret"
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "icon-folder",
      attrs: {
        "fill": _vm.theme.accent,
        "width": "24",
        "height": "24"
      }
    }, [_c('use', {
      attrs: {
        "href": "#iconCaiet"
      }
    })]), _vm._v("\n          " + _vm._s(folder.t) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "poems",
      style: ({
        color: _vm.theme.text2
      })
    }, _vm._l((folder.p), function(poem) {
      return _c('router-link', {
        key: ("" + (poem.n)),
        attrs: {
          "id": ("" + (poem.n)),
          "to": {
            name: 'Poem',
            params: {
              nr: +poem.n,
              title: _vm.formatTitle(poem.t)
            }
          }
        }
      }, [_c('span', {
        staticClass: "link-span",
        on: {
          "click": _vm.tapPoemLink
        }
      }, [_c('span', {
        staticClass: "link-span__nr"
      }, [_vm._v(_vm._s(poem.n))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(poem.t))])])])
    }), 1)])
  }), _vm._v(" "), _c('loading', {
    staticClass: "loading",
    attrs: {
      "color": _vm.theme.accent
    }
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2daa5714","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarLeft.vue
// module id = 129
// module chunks = 1